/**
 * Confirm OTP  provides the user interface for the user to
 * key in the OTP sent by the system during the rest password
 * process
 */

import React from "react";
import PropTypes from "prop-types";
import theme from "../../../../assests/theme";
import {
  MuiButton,
  MuiTextField,
  MuiCompareIcon,
  MuiSnackbar,
  MuiTypography,
  muiWithStyles,
  MuiInputAdornment,
  MuiGrid
} from "../../../ui/MaterialUIComponents";
import PageContainer from "../../../ui/PageContainer";
import MaterialUIForm from "material-ui-form";
import { Confirm } from "react-cognito";
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
export class ConfirmForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      verificationCode: "",
      message: "",
      snackBarOpenFlag: false
    };
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  snackBarOpen = toastMsg => {
    this.setState({ snackBarOpenFlag: true, message: toastMsg });
  };

  snackBarClose = () => {
    this.setState({ snackBarOpenFlag: false });
  };

  validate = () => {
    if (this.state.verificationCode.length < 6) {
      this.setState({ error: "invalid Verification Code" });
      return false;
    } else {
      return true;
    }
  };

  onSubmit = () => {
    if (this.validate()) {
      this.props
        .onSubmit(this.state.verificationCode)
        .then(user => {
          this.setState({ error: "", verificationCode: "" });
          this.snackBarOpen("Verified Account Successfully");
        })
        .catch(error => {
          this.setState({ error });
        });
    }
  };

  onResend = event => {
    event.preventDefault();
    this.props
      .onResend()
      .then(user => {
        this.setState({ error: "Code resent to registered email" });
      })
      .catch(error => {
        this.setState({ error });
      });
  };

  render = () => (
    <div className="App">
      <MuiSnackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.snackBarOpenFlag}
        onClose={this.snackBarClose}
        autoHideDuration="1000"
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={<span id="message-id">{this.state.message}</span>}
      />

      <MaterialUIForm id="form" onSubmit={this.onSubmit}>
        <br />
        <MuiGrid container>
          <MuiTypography
            id="OTP-Title"
            variant={theme.typographyStyles.TITLE}
            style={theme.typographyTitle}
          >
            Verification
          </MuiTypography>
          <MuiTypography
            variant={theme.typographyStyles.CAPTION}
            style={theme.typographyDescription}
          >
            A confirmation code has been sent to your email address{" "}
          </MuiTypography>

          <MuiGrid item lg={12} xs={12}>
            <MuiTextField
              id="verficationcode"
              label="Verification Code"
              name="verificationCod"
              onChange={this.handleChange("verificationCode")}
              placeholder="Enter 6 digit verfication code"
              style={{ width: "100%" }}
              data-validators="isRequired"
              InputProps={{
                endAdornment: (
                  <MuiInputAdornment position="end">
                    <MuiCompareIcon />
                  </MuiInputAdornment>
                )
              }}
              required
            />
            <br />
            <MuiTypography
              variant={theme.typographyStyles.CAPTION}
              color="secondary"
            >
              {this.state.error}
            </MuiTypography>
            <MuiButton
              id="ResendOTP-Button"
              variant="flat"
              style={theme.actionButton}
              onClick={this.onResend}
            >
              Resend code
            </MuiButton>
          </MuiGrid>
          <MuiGrid item container justify="space-around">
            <MuiButton
              id="Submit-Button"
              variant="flat"
              style={theme.actionButton}
              type="submit"
            >
              Submit
            </MuiButton>
            <MuiButton
              id="Cancel-Button"
              variant="flat"
              style={theme.actionButton}
              onClick={this.props.onCancel}
            >
              Cancel
            </MuiButton>
          </MuiGrid>
        </MuiGrid>
      </MaterialUIForm>
    </div>
  );
}
ConfirmForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onResend: PropTypes.func,
  error: PropTypes.string,
  message: PropTypes.string
};
const ConfirmOTP = () => (
  <PageContainer>
    <Confirm>
      <ConfirmForm />
    </Confirm>
  </PageContainer>
);

const componentStyle = theme => ({});

export default withAppShell((muiWithStyles(componentStyle)(ConfirmOTP)), { properties: { isProtected: false } });
